import { render, staticRenderFns } from "./DataReferenceModule.vue?vue&type=template&id=157d5324"
import script from "./DataReferenceModule.vue?vue&type=script&lang=js"
export * from "./DataReferenceModule.vue?vue&type=script&lang=js"
import style0 from "./DataReferenceModule.vue?vue&type=style&index=0&id=157d5324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports